/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthenticationService, HttpResponse, Logger } from '@app/core';
import { Observable } from 'rxjs';
import {
  PushNotificationOptions,
  PushNotificationService,
} from '@app/core/push-notifications/push-notifications.service';

const log = new Logger('TimeTracking');

@Injectable({
  providedIn: 'root',
})
export class TimeTrackingService {
  /**
   * Дали да работи?
   */
  private enableTimeTracking = true;

  /**
   * През колко време да праща данните до сървъра
   */
  private pingSeconds: number = 60 * 5;

  /**
   * След колко време да логаутне юзъра ако не ползва системата
   */
  private idleSeconds: number = 60 * 15;

  /**
   * Колко време преди излизане да извести юзъра
   */
  private idleTimeOutSeconds = 60;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private http: HttpClient,
    private authService: AuthenticationService,
    private pushNotificationService: PushNotificationService
  ) {}

  start() {
    if (!this.enableTimeTracking) {
      log.error('Stopped!');
      return;
    }

    log.info('Start...');

    // sets an idle timeout
    this.idle.setIdle(this.idleSeconds);

    // sets a timeout
    this.idle.setTimeout(this.idleTimeOutSeconds);

    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // this.idle.onIdleEnd.subscribe(() => {
    //   console.log('No longer idle.');
    // });

    this.idle.onTimeout.subscribe(() => {
      if (!this.authService.isAuthenticated()) {
        return;
      }

      log.error('timeout...');
      this.authService.logout().subscribe(() => {
        // go to login or other page for this error!?
        window.location.reload();
      });
    });

    this.idle.onIdleStart.subscribe(() => {
      if (!this.authService.isAuthenticated()) {
        return;
      }

      /*
      Да покажем нотификация на юзъра!
       */
      log.error('idle start');
      const title = 'Ехоо, май не бачкаш?';
      const options = new PushNotificationOptions();
      options.body = 'Връщай се обратно! :D';
      options.icon = window.location.origin + '/assets/logo-32x32-notification.png';
      this.pushNotificationService.create(title, options).subscribe(
        (notif) => {
          if (notif.event.type === 'show') {
            setTimeout(() => {
              notif.notification.close();
            }, 10000);
          }
        },
        () => {}
      );
    });

    // this.idle.onTimeoutWarning.subscribe((countdown: number) => {
    //   log.info('warning: ' + countdown);
    // });

    // sets the ping interval
    this.keepalive.interval(this.pingSeconds);

    this.keepalive.onPing.subscribe(() => {
      if (!this.authService.isAuthenticated()) {
        log.info('User is not authenticated!');
        return;
      }
      return this.ping().subscribe(
        () => {
          log.debug('Logged time', this.pingSeconds + ' seconds');
        },
        (e) => {
          const title = 'Грешка при записване на работно време!';
          const options = new PushNotificationOptions();
          options.body = 'Системата не е записала работното ви време от ' + this.pingSeconds + ' секунди!';
          options.icon = window.location.origin + '/assets/logo-32x32-notification.png';
          this.pushNotificationService.create(title, options).subscribe(
            (notif) => {
              if (notif.event.type === 'show') {
                setTimeout(() => {
                  notif.notification.close();
                }, 10000);
              }
            },
            () => {}
          );
        }
      );
    });

    this.idle.watch();
  }

  private ping(): Observable<HttpResponse> {
    log.info('Log time tracking: ' + this.pingSeconds + ' seconds');
    return this.http.post('v1/time_tracking', { seconds: this.pingSeconds }).pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }
}
